import { MutableRefObject, useEffect, useRef } from 'react';
import { functionNoop } from '../function/noop';

/**
 * Hook that simulates the class constructor behavior
 * It'll be run only before rendering
 * @param callback Function that will be invoked once on component initialization
 */
export const useReactConstructor = (callback: () => void | (() => void)): void => {
  const hasBeenCalledRef = useRef(false);
  const unmountRef: MutableRefObject<() => void | (() => void)> = useRef(functionNoop);

  useEffect(() => {
    return (): void => {
      if (unmountRef.current) {
        unmountRef.current();
      }
    };
  }, []);

  if (hasBeenCalledRef.current) {
    return;
  }

  const unmount = callback();
  if (unmount) {
    unmountRef.current = unmount;
  }
  hasBeenCalledRef.current = true;
};
